import { getAssetsImage } from "@Components/Modules/Helpers";
import type { OmitStyles } from "@stylex/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

export interface IShareLink extends OmitStyles<React.ButtonHTMLAttributes<HTMLButtonElement>> {
    iconStyleX?: stylex.StyleXStyles;
}

const ShareLink = (props: IShareLink) => {
    const { styleX, children = undefined, iconStyleX, ...all } = props;

    return (
        <button {...all} {...stylex.props(styleX)} type="button">
            <img {...stylex.props(iconStyleX)} src={getAssetsImage(process.env.ShareIcon)} alt="Share Icon" />
            {children}
        </button>
    );
};

export default ShareLink;
